import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationReplyToSavedDocumentThreadArgs,
  BackendSavedDocumentThread,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ReplyToSavedDocumentThread($threadId: ID!, $text: String!) {
    replyToSavedDocumentThread(threadId: $threadId, text: $text) {
      id
    }
  }
`;

type Variables = BackendMutationReplyToSavedDocumentThreadArgs;
type Result = Pick<BackendSavedDocumentThread, 'id'>;

export const replyToSavedDocumentThread = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
